<script setup lang="ts">
import LeftMenu from '~/component/menu/LeftMenu.vue'

const moveToBack = () => {
  useRouter().back()
}
</script>
<template>
  <!-- #wrap -->
  <div id="wrap">
    <LeftMenu />
    <hr />
    <!-- /#header -->
    <header id="header" class="headerType02">
      <a class="btnHeaderBack" @click="moveToBack">돌아가기</a>
    </header>
    <!-- /#header -->
    <slot></slot>
    <hr />
  </div>
  <!-- /#wrap -->
</template>
<style>
@import '@/assets/css/style.css';
</style>
